// import React, { useCallback } from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { ADGMTextField } from 'aurora-components';
import messages from 'aurora-translations';
import styles from './styles';

function BrokerFields(props) {
  const { classes, locale, intl, formState, apiResponse, handleStateChange } = props;

  return (
    <div className={classes.inputGridContainer}>
      <ADGMTextField
        name='firstName'
        type='text'
        label={intl.formatMessage({ ...messages.broker_name_english })}
        placeholder={intl.formatMessage({ ...messages.Name_English })}
        dir='ltr'
        required
        onChange={handleStateChange}
        value={apiResponse?.firstName || apiResponse?.nameEn || ''}
        disabled={!isEmpty(apiResponse?.firstName || apiResponse?.nameEn)}
        customClasses={{ field: !isEmpty(apiResponse?.firstName || apiResponse?.nameEn) && classes.calculatedField }}
      />
      <ADGMTextField
        name='firstArabicName'
        type='text'
        label={intl.formatMessage({ ...messages.broker_name_arabic })}
        placeholder={intl.formatMessage({ ...messages.Name_Arabic })}
        dir='rtl'
        required
        onChange={handleStateChange}
        value={apiResponse?.firstArabicName || apiResponse.nameAr || ''}
        disabled={!isEmpty(apiResponse?.firstArabicName || apiResponse.nameAr)}
        customClasses={{
          field: !isEmpty(apiResponse?.firstArabicName || apiResponse.nameAr) && classes.calculatedField,
        }}
      />

      <ADGMTextField
        name='registrationLicenseNumber'
        type='text'
        label={<FormattedMessage {...messages.registration_license_number} />}
        placeholder={intl.formatMessage({ ...messages.TRN_example })}
        required
        onChange={handleStateChange}
        value={apiResponse?.registrationLicenseNumber || formState.registrationLicenseNumber || ''}
        disabled={!isEmpty(apiResponse?.registrationLicenseNumber)}
        customClasses={{
          field: !isEmpty(apiResponse?.registrationLicenseNumber) && classes.calculatedField,
        }}
      />

      <ADGMTextField
        name='companyNameEn'
        type='text'
        label={<FormattedMessage {...messages.company_name_english} />}
        placeholder={intl.formatMessage({ ...messages.company_name_english_hint })}
        dir='ltr'
        required
        onChange={handleStateChange}
        value={apiResponse?.companyName || formState.companyName || ''}
        disabled={!isEmpty(apiResponse?.companyName)}
        customClasses={{
          field: !isEmpty(apiResponse?.companyName) && classes.calculatedField,
        }}
      />

      <ADGMTextField
        name='companyNameAr'
        type='text'
        label={<FormattedMessage {...messages.company_name_arabic} />}
        placeholder={intl.formatMessage({ ...messages.company_name_arabic_hint })}
        dir='rtl'
        required
        onChange={handleStateChange}
        value={apiResponse?.companyNameAr || formState.companyNameAr || ''}
        disabled={!isEmpty(apiResponse?.companyNameAr)}
        customClasses={{
          field: !isEmpty(apiResponse?.companyNameAr) && classes.calculatedField,
        }}
      />

      <ADGMTextField
        name='companyTradeLicenseNumber'
        type='text'
        label={<FormattedMessage {...messages.LICENSE} />}
        placeholder={intl.formatMessage({ ...messages.company_trade_license_eg })}
        required
        onChange={handleStateChange}
        value={apiResponse?.companyTradeLicenseNumber || formState.companyTradeLicenseNumber || ''}
        disabled={!isEmpty(apiResponse?.companyTradeLicenseNumber)}
        customClasses={{
          field: !isEmpty(apiResponse?.companyTradeLicenseNumber) && classes.calculatedField,
        }}
      />

      <ADGMTextField
        name='nationalityEn'
        type='text'
        label={<FormattedMessage {...messages.nationality} />}
        placeholder='Nationality'
        required
        style={{ order: 4 }}
        value={locale === 'ar' ? apiResponse?.nationalityAr || '' : apiResponse?.nationalityEn || ''}
        disabled
        customClasses={{ field: classes.calculatedField }}
      />

      <ADGMTextField
        name='phoneNumber'
        type='text'
        label={<FormattedMessage {...messages.phone_number} />}
        placeholder={<FormattedMessage {...messages.phone_number} />}
        required
        onChange={handleStateChange}
        value={apiResponse?.phoneNumber || apiResponse.phone || formState.phoneNumber || ''}
        disabled={!isEmpty(apiResponse?.mobileNo || apiResponse.phone)}
        customClasses={{
          field: !isEmpty(apiResponse?.phoneNumber || apiResponse.phone) && classes.calculatedField,
        }}
      />
      <ADGMTextField
        name='email'
        type='text'
        label={<FormattedMessage {...messages.Email} />}
        placeholder={<FormattedMessage {...messages.Email} />}
        required
        onChange={handleStateChange}
        value={apiResponse?.email || formState.email || ''}
        disabled={!isEmpty(apiResponse?.email)}
        customClasses={{ field: !isEmpty(apiResponse?.email) && classes.calculatedField }}
      />
    </div>
  );
}

BrokerFields.propTypes = {
  classes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  apiResponse: PropTypes.object.isRequired,
  isResponseCompany: PropTypes.bool.isRequired,
  isResponsePerson: PropTypes.bool.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func,
};

BrokerFields.defaultProps = {
  handleSelect: null,
};

export default withStyles(styles)(BrokerFields);
